import { render, staticRenderFns } from "./lottery-title.vue?vue&type=template&id=0f8bb06e&"
import script from "./lottery-title.vue?vue&type=script&lang=js&"
export * from "./lottery-title.vue?vue&type=script&lang=js&"
import style0 from "./lottery-title.vue?vue&type=style&index=0&id=0f8bb06e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports